export class CaseExportTemplateApi {
  constructor(protected baseUrl: string) {}

  public exportProperties(): string {
    return `${this.baseUrl}/virtual-clinics/master-exports/properties/tree`;
  }

  public exportDefaultTemplates(): string {
    return `${this.baseUrl}/virtual-clinics/master-exports/defaults/`;
  }

  public caseExportTemplates(): string {
    return `${this.baseUrl}/case-export-templates/`;
  }

  public caseExportTemplateById(templateId: string): string {
    return `${this.baseUrl}/case-export-templates/${templateId}`;
  }
}
